import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import React from 'react';
const expertSkil = [
    { id: 1, name: 'Docker', progress: 60 },
    { id: 2, name: 'CI/CD', progress: 40 },
    { id: 3, name: 'JEST', progress: 70 },
    { id: 4, name: 'JIRA', progress: 80 },
    { id: 5, name: 'React Testing Library', progress: 60},
    { id: 6, name: 'Send-In-Blue', progress: 80 },
    { id: 7, name: 'Expo CLI', progress: 70 },
    { id: 9, name: 'Zoho', progress: 70 },
    { id: 10, name: 'Yarn', progress: 80 },
    { id: 12, name: 'vercel', progress: 80 },
]
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 12,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === 'light' ? '#10B981' : '#308fe8',
    },
  }));
export default function Tools() {
    return (
        <Grid container spacing={3} sx={{padding: '5px 16px'}}>
            {
                expertSkil.map((item) => {
                    return (
                        <Grid item xs={6} lg={6} md={6} key={item.id}>
                            {/* <Card sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#250647', color: '#fff' }}> */}
                                {/* <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <CardContent sx={{ flex: '1 0 auto' }}>
                                        <Typography component="div" variant="h5">
                                            {item.name}
                                        </Typography>
                                    </CardContent> */}
                                    {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Box sx={{ width: '100%', ml: 1, mr: 1 }}>
                                        <LinearProgress variant="determinate" value={item.progress} />
                                    </Box>
                                    <Box sx={{ minWidth: 35 }}>
                                        <Typography variant="body2" color="text.secondary">{`${item.progress
                                            }%`}</Typography>
                                    </Box>
                                </Box> */}

                                {/* </Box> */}
                                {/* <CardContent>
                                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                        <CircularProgress variant="determinate" value={item.progress} size={40}
                                            thickness={4} style={{color: '#ed810e'}} />
                                        <Box
                                            sx={{
                                                top: 0,
                                                left: 0,
                                                bottom: 0,
                                                right: 0,
                                                position: 'absolute',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <Typography variant="caption" component="div" style={{color: '#ed810e'}}>
                                                {`${item.progress}%`}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </CardContent> */}
                                <Box sx={{width: '100%'}}>
                                    <Typography sx={{color: '#fff'}}>{item.name} - ({item.progress}%)</Typography>
                                    <BorderLinearProgress variant="determinate" value={item.progress} />
                                    {/* <LinearProgress variant="determinate" color="secondary" size={120} thickness={6} value={item.progress} valueBuffer={80}/> */}
                                </Box>
                            {/* </Card> */}
                        </Grid>

                    )
                })
            }

        </Grid>
    )
}
